import "./MainHeader.css";
import ButtonIcon from "../../buttons/buttonIcon/ButtonIcon";
import { NavLink } from "react-router-dom";

const MainHeader = ({
  icon,
  rightIcon,
  leftIcon,
  title,
  button,
  buttonText,
  link,
  children,
}) => {
  return (
    <div className="main_header">
      <div className="left_header_title">
        {leftIcon && <span className="main_header_icon">{leftIcon}</span>}
        <span className="main_header_text">
          {title} {rightIcon && <div>{rightIcon}</div>}
        </span>
      </div>
      {button && (
        <div className="header_button">
          <NavLink to={link} style={{ textDecoration: "none" }}>
            <ButtonIcon
              backgroundColor="#633ccd"
              color="#ffffff"
              icon={icon}
              buttonText={buttonText}
              
            />
          </NavLink>
        </div>
      )}
      {children && <div className="header_button">{children}</div>}
    </div>
  );
};

export default MainHeader;
